export default __webpack_public_path__ + "static/media/medium.79a28a4a.svg";